<div *ngIf="!formReadonlyMode">
    <mat-form-field class='mxs-input mxs-input--password' [formGroup]="form"
                    [ngClass]="{'hidden': hidden}"
                    [matTooltip]="getTooltipValidationMessage(name) | translate"
                    [matTooltipClass]="'mxs-error-ttip'">
        <mat-label>{{getLabel() | translate}}</mat-label>
        <input matInput
               [formControlName]="name"
               [errorStateMatcher]="errorService"
               [required]="required"
               [type]="hidePassword ? 'password' : 'text'"
               autocomplete="new-password"
        />
        <mat-icon matSuffix (click)="hidePassword = !hidePassword">{{hidePassword ? 'visibility' : 'visibility_off'}}
        </mat-icon>
        <mat-hint style="position: absolute">{{getHint() | translate}}</mat-hint>
        <mat-error *ngFor="let error of getPasswordValidationMessages(name)">
            {{getError(error) | translate}}
        </mat-error>
    </mat-form-field>
    <mat-form-field class='mxs-input mxs-input--password' [formGroup]="form"
                    [ngClass]="{'hidden': hidden}"
                    [matTooltip]="getTooltipValidationMessage(name + ' retype') | translate"
                    [matTooltipClass]="'mxs-error-ttip'">
        <mat-label>{{(getRetypeLabel()) | translate}}</mat-label>
        <input matInput
               [errorStateMatcher]="errorService"
               [required]="required"
               [formControlName]="name + ' retype'"
               [type]="hidePassword ? 'password' : 'text'"
               autocomplete="new-password"
        />
        <mat-icon matSuffix (click)="hidePassword = !hidePassword">{{hidePassword ? 'visibility' : 'visibility_off'}}
        </mat-icon>
        <mat-hint style="position: absolute">{{hint}}</mat-hint>
        <mat-error *ngFor="let error of getPasswordValidationMessages(name + ' retype')">
            {{getError(error) | translate}}
        </mat-error>
    </mat-form-field>
</div>

<!--In formReadonlyMode display nothing-->
